import {RootEpic} from 'StoreTypes';
import {from, of, defer} from 'rxjs';
import {filter, switchMap, map, catchError} from 'rxjs/operators';
import {isActionOf} from 'typesafe-actions';
import {authenticateAsync, loadUserAsync, logoutAsync, refreshTokenAsync} from './actions';
import Api from '../../services/assistant-client';
import { User } from 'UserFeature';
import { localize } from '../../localization';

export const authenticationEpic: RootEpic = (action$, state$, {api}) =>
  action$.pipe(
    filter(isActionOf(authenticateAsync.request)),
    switchMap((action) => {
      return from(
        api.assistant.login(action.payload.token, action.payload.provider),
      ).pipe(
        map((authResponse) => {
          api.assistant.updateAuthToken(authResponse.accessToken)
          Api.updateAuthToken(authResponse.accessToken);
          return authenticateAsync.success(authResponse);
        }),
        catchError((err) => {
          let errorMessage;
          switch (err.status) {
            case 1000:
              errorMessage = localize('ERROR_USER_DISABLED');
              break;
            default:
              errorMessage = localize('ERROR_DEFAULT');
          }
          return of(authenticateAsync.failure(errorMessage))
        }),
      );
    }),
  );

export const loadUserEpic: RootEpic = (action$, state$, { api }) =>
  action$.pipe(
    filter(isActionOf([loadUserAsync.request])),
    switchMap((_action) =>
      defer(() => from(api.assistant.fetchUser(state$.value.login.user.id))).pipe(
        map((data) => data as User),
        map(loadUserAsync.success),
        catchError((error) => of(loadUserAsync.failure(error.message))),
      ),
    ),
  );

export const logoutEpic: RootEpic = (action$, state$, {api}) =>
  action$.pipe(
    filter(isActionOf(logoutAsync.request)),
    map((_action) => {
      return logoutAsync.success();
    }),
  );

export const refreshAuthTokenEpic: RootEpic = (action$, state$, {api}) =>
  action$.pipe(
    filter(isActionOf(refreshTokenAsync.request)),
    switchMap((action) => {
      return from(
        api.auth.refreshAuthToken(
          state$.value.login.authtoken.refreshToken ?? '',
        ),
      ).pipe(
        map((authToken) => {
          api.assistant.updateAuthToken(authToken.token);
          return refreshTokenAsync.success(authToken);
        }),
        catchError((message) => of(refreshTokenAsync.failure(message))),
      );
    }),
  );
